import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '@store/app.state';
import { selectPermissions } from '@store/selectors/permission.selectors';

@Injectable({
    providedIn: 'root',
})
export class PermissionService implements OnDestroy {
    private destroy$ = new Subject<void>();
    private permissions$ = new BehaviorSubject<string[]>([]);

    constructor(private store: Store<AppState>) {
        this.store
            .select(selectPermissions)
            .pipe(takeUntil(this.destroy$))
            .subscribe((permissions: string | string[] | null) => {
                this.permissions$.next(permissions as string[]);
            });
    }

    getPermissions(): string[] {
        return this.permissions$.getValue();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
